export default {
	title: 'Indicators',
	url: 'indicators',
	subtitle:
		"List your success indicators and organise them by category — by default, the 4 Balanced Scorecard perspectives: Financial, Customer, Internal processes, Learning & growth. The Visualisation tab lays them out as a balanced scorecard, with their evolution per scenario.",
	no_description: 'No defined indicator',
	context_worse: 'Negative',
	context_best: 'Positive',
	tabs: {
		filters: {
			title: 'View filters'
		},
		general: {
			title: 'General'
		},
		export: {
			title: 'Export'
		},
		comments: {
			title: 'History'
		},
		bot: {
			title: 'AI'
		}
	},
	messages: {
		edit_constraint: 'Indicator edition',
		create_constraint: 'Create a new indicator'
	},
	onboarding: {
		title: 'Indicators review',
		description:
			"Check that the indicators cover the Balanced Scorecard categories and link back to the action plan."
	}
};
